import { useEffect, useState } from 'react';
import { useVATStore } from '../../stores/VATStore';
import EndUserDetails from './EndUserDetails';

const VATCheck = () => {
    const { setFormValue, newCustomerForm, showVATModal } = useVATStore();
    const [vatExempt, setVatExempt] = useState(false);
    const handleVatExempt = (event: React.ChangeEvent<HTMLInputElement>) => { setVatExempt(event.target.checked); };

    useEffect(() => {
        setVatExempt(newCustomerForm.vat_exempt === true ? true : false);
    }, [newCustomerForm]);

    useEffect(() => {
        setFormValue('vat_exempt', [], vatExempt);
    }, [vatExempt]);

    return (<>
        <label className='ncf-title'>VAT</label>
        <div className='input-group'>
            <label className="custom-checkbox">
                <input type="checkbox"
                    checked={vatExempt}
                    onChange={handleVatExempt}
                />
                <span></span>
                I declare that I or the Alarm User qualify for VAT Relief.
                <button style={{ border: '0px' }} className='no-style' onClick={(e) => { e.preventDefault(); showVATModal(true); }}><img width={'15px'} height={'15px'} src={(window as any).gcl_exclamation} /></button>
            </label>
        </div>
    </>
    );
};

export default VATCheck;

